import React from 'react';
import ReactJson from 'react-json-view'
import {jsonComponentCustomTheme} from "../App/theme";

export const JSONComponent = ({data, props, enableClipboard = false, collapsed = true}) => {

    if (!data) return null

    return <ReactJson theme={jsonComponentCustomTheme}
                      style={{fontSize: 14, width: '80%', borderRadius: '20px', paddingTop: '8px', paddingLeft: '8px'}}
                      src={data}
                      displayDataTypes={false}
                      name={null}
                      enableClipboard={enableClipboard}
                      collapsed={collapsed}
                      // collapseStringsAfterLength={80}
                      {...props} />
};

